import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["tagName", "innerRef", "isPlainText"];
import { useEffect, memo, useCallback, useRef } from 'react';
import styled from 'foundations-theming/utils';
import { formatHtml } from '../sanitizers/HtmlSanitizer';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledText = styled(props => {
  const {
      tagName: Tag,
      innerRef: ref
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(Tag, Object.assign({
    ref: ref
  }, rest));
}).withConfig({
  displayName: "SanitizedText__StyledText"
})(["white-space:", ";table{margin-top:", ";margin-bottom:", ";}pre{white-space:pre-wrap;}[data-email-reply]{display:none;}"], ({
  isPlainText
}) => isPlainText && 'pre-wrap', ({
  theme
}) => theme.space['0'], ({
  theme
}) => theme.space['0']);
const SanitizedText = /*#__PURE__*/memo(({
  body,
  formattingOptions,
  config: sanitizeConfig,
  maxHeight,
  onExceedsMaxHeight,
  textSeleniumKey,
  WrapperComponent = 'div'
}) => {
  const fullHeightTextRef = useRef(null);
  const formattedBody = body ? formatHtml(body, Object.assign({}, formattingOptions, sanitizeConfig && {
    config: sanitizeConfig
  })) : '';
  const handleExceedsMaxHeight = useCallback((onResize = true) => {
    if (!fullHeightTextRef || !fullHeightTextRef.current || !maxHeight) {
      return;
    }
    if (fullHeightTextRef.current.clientHeight > maxHeight) {
      if (onExceedsMaxHeight) onExceedsMaxHeight(true);
    } else if (onResize) {
      if (onExceedsMaxHeight) onExceedsMaxHeight(false);
    }
  }, [maxHeight, fullHeightTextRef, onExceedsMaxHeight]);
  useEffect(() => {
    const isNumericMaxHeight = maxHeight && !isNaN(maxHeight);
    const allowMaxHeightTruncation = isNumericMaxHeight && formattedBody;
    if (allowMaxHeightTruncation) {
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      window.addEventListener('resize', handleExceedsMaxHeight);
      handleExceedsMaxHeight(false);
      return () => {
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        window.removeEventListener('resize', handleExceedsMaxHeight);
      };
    }
    return undefined;
  }, [maxHeight, formattedBody, handleExceedsMaxHeight]);
  if (!formattedBody) {
    return null;
  }
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledText, {
      dangerouslySetInnerHTML: {
        __html: formattedBody
      },
      "data-test-id": textSeleniumKey,
      isPlainText: Boolean(formattingOptions && formattingOptions.isPlainText),
      tagName: WrapperComponent,
      innerRef: fullHeightTextRef
    })
  );
});
export default SanitizedText;